import type { ShallowStudentResource } from "api/generated";
import type { ShallowStudent } from "shared/types";

export const shallowStudentFromDto = (
  resource: ShallowStudentResource,
): ShallowStudent => ({
  id: resource.id,
  firstName: resource.first_name,
  middleName: resource.middle_name ?? null,
  lastName: resource.last_name,
  studentNumber: resource.student_number ?? null,
  formattedName: resource.formatted_name,
  fullName: resource.full_name,
  educationLevel: resource.education_level ?? null,
  educationYear: resource.education_year ?? null,
  formattedEducationLevel: resource.formatted_education_level,
  mentorClass: resource.mentor_class,
  lessonGroups: resource.lesson_groups,
  profileImage: resource.profile_image || null,
  mentors: resource.mentors.map((mentor) => ({
    id: mentor.id,
    name: mentor.name,
    shortage: mentor.shortage,
  })),
});

export const shallowStudentToDto = (
  student: ShallowStudent,
): ShallowStudentResource => ({
  id: student.id,
  first_name: student.firstName,
  middle_name: student.middleName ?? "",
  last_name: student.lastName,
  student_number: student.studentNumber ?? "",
  formatted_name: student.formattedName,
  full_name: student.fullName,
  education_level: student.educationLevel ?? null,
  education_year: student.educationYear ?? null,
  formatted_education_level: student.formattedEducationLevel,
  mentor_class: student.mentorClass,
  lesson_groups: student.lessonGroups,
  profile_image: student.profileImage ?? null,
  mentors: student.mentors.map((mentor) => ({
    id: mentor.id,
    name: mentor.name,
    shortage: mentor.shortage,
  })),
});
